<template>
  <v-layout column wrap  style="overflow-y: auto;">
    <v-toolbar dark class="toolbarcreatedadmin" style="margin-top: 20px;">
      <img :src="BASE_URL + 'static/icon/helping.svg'" alt="" width="40px"> &nbsp;&nbsp;
      <v-toolbar-title>ข้อมูล การขอความช่วยเหลือ</v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
        <!-- <v-text-field
          hide-details
          solo
          v-model="search"
          append-icon="search"
          label="ค้นหาจากชื่อบริษัท"
          style="width: 330px;display: -webkit-inline-box; margin-right: 20px;"
        ></v-text-field>
         <v-select
          :items="itemsselect"
          v-model="selectKey"
          item-text="text"
          item-value="value"
          solo
          hide-details
          ligth
          style="width: 200px;display: -webkit-inline-box; margin-right: 20px;"
        ></v-select> -->
      </div>
    </v-toolbar>
    <v-layout row wrap justify-center align-center style="margin-top: 20px;">
    <v-data-table
      :headers="headers"
      :items="listhelping"
      :items-per-page="10"
      class="elevation-1"
      @click:row="selectedDetailHelping"
      style="cursor: pointer;"
    >
      <template v-slot:item.company_type="{ item }">
        <v-chip small v-if="item.company_type == 'owner'" style="background: #a80e00;color: white;">
          บริษัทในเครือสภากาชาด
        </v-chip>
        <v-chip small v-else-if="item.company_type == 'partner'"> บริษัทร่วมโครงการ </v-chip>
        <v-chip small v-else-if="item.company_type == 'maintenance'"> บริษัทบำรุงรักษาเครื่อง AED </v-chip>
        <!-- {{item.company_type}} -->
      </template> 
      <template v-slot:item.type_helping="{ item }">
        <!-- {{ helpingtype(item.is_cpr, item.is_runner) }} -->
        <div v-if="item.is_cpr && item.is_runner">
          <v-chip small > cpr </v-chip> , <v-chip small style="background: #a80e00;color: white;"> AED </v-chip>
        </div>
        <div v-else-if="item.is_cpr">
          <v-chip small > cpr </v-chip>
        </div>
        <div v-else-if="item.is_runner">
          <v-chip small style="background: #a80e00;color: white;"> AED </v-chip>
        </div>
      </template>
      <template v-slot:item.cpr="{ item }">
        {{ count_vulunteer(item.list_users_accept, 'cpr') }}
      </template>

      <template v-slot:item.aed="{ item }">
        {{ count_vulunteer(item.list_users_accept, 'runner') }}
      </template>

      <template v-slot:item.cancel="{ item }">
        {{ count_vulunteer(item.list_users_accept, 'cancel') }}
      </template>

      <template v-slot:item.status="{ item }">
        {{ (item.status == 'open')? 'เปิด':'สำเร็จแล้ว' }}
      </template>

      <template v-slot:item.time_request="{ item }">
        {{ dateMoment(item.time_request)}} - {{ timeMoment(item.time_request)}}น.
      </template>
    </v-data-table>
    </v-layout>
    <EditCompany :dialogedit_company="dialogedit_company" headid="" :Company="CompanyData" @closeedit_company="closeedit_company"></EditCompany>
  </v-layout>
</template>
<script>
var _ = require('lodash')
import { Decode, Momenttime } from '@/services'
import EditCompany from '@/components/edit/edit_company_modal'
export default {
  data () {
    return {
      dialogedit_company: false,
      BASE_URL: process.env.BASE_URL,
      items: [],
      selectKey: 'all',
      itemsselect: [
        { text: 'ทั้งหมด', value: 'all' },
        { text: 'บริษัทในเครือสภากาชาด', value: 'owner' },
        { text: 'บริษัทร่วมโครงการ', value: 'partner' },
        { text: 'บริษัทบำรุงรักษาเครื่อง AED', value: 'maintenance' }
      ],
      search: '',
      headers: [
        { text: 'ผู้ขอความช่วยเหลือ', value: 'name_user_request' },
        { text: 'ประเภทของการขอความช่วยเหลือ', value: 'type_helping'},
        { text: 'Hero CPR (คน)', value: 'cpr', sortable: false},
        { text: 'Run for AED (คน)', value: 'aed', sortable: false },
        { text: 'ปฏิเสธให้การช่วยเหลือ (คน)', value: 'cancel', sortable: false },
        { text: 'สถานะ', value: 'status' },
        { text: 'วัน เวลา', value: 'time_request' }
      ],
      listhelping: [],
      authen: {},
      headerAPI: {},
      CompanyData: {}
    }
  },
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.getHelping()
  },
  components: {
    EditCompany
  },
  computed: {
    listCompanyFile () {
      if (this.search !== '' && this.search !== null) {
        return _.reject(this.listCompanyMode, ['company_owner_name', null]).filter(post => {
          try {
            return post.company_owner_name.toLowerCase().includes(this.search.toLowerCase()) || post.company_maintenance_name.toLowerCase().includes(this.search.toLowerCase())
          } catch(err) {
          }
        })
      } else {
        return this.listCompanyMode
      }
    },
    listCompanyMode () {
      if (this.selectKey == 'all') {
        return this.listCompany
      } else {
        return this.listCompany.filter(post => {
            return post.company_type.toLowerCase().includes(this.selectKey.toLowerCase())
        })
      }
    }
  },
  methods: {
    count_vulunteer (list, type) {
      if (list.length == 0) {
        return 0
      } else if (type == 'cancel') {
        return _.filter(list, { 'accept_status': type}).length
      } else {
        return _.filter(list, { 'type_accept': type, 'accept_status': 'accept'}).length
      }
    },
    // helpingtype (cpr, runner) {
    //   if (cpr && runner) {
    //     return ['cpr', 'ขอAED']
    //   } else if (cpr) {
    //     return ['cpr']
    //   } else if (runner) {
    //     return ['ขอAED']
    //   } else {
    //     return []
    //   }
    // },
    closeedit_company (value, update) {
      this.dialogedit_company = value
      if (update) {
        this.getlistCompany()
      }
    },
    selectedDetailHelping (item, row) {
      // console.log(item)
      this.$router.push('/information_requestHelping?id='+item.request_id)
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    getHelping () {
      this.axios.get(process.env.API_BACKEND + '/v1/getAskForHelpData', {headers: this.headerAPI}).then((response) => {
        this.listhelping = response.data
      })
    }
  }
}
</script>
<style media="screen" scoped>
>>>.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot {
    border-radius: 30px;
    background: #ffffff;
    color: #a80e00;
    border-color: #a80e00;
    border-style: solid;
    border-width: thin;
}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.theme--dark.v-select .v-select__selections {
    color: #a80e00 !important;
}
>>>.theme--dark.v-label {
    color: hsl(5, 100%, 33%) !important;
}
>>>.theme--dark.v-icon {
    color: #a80e00 !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
  color: #a80e00 !important;
}
>>>.v-select__selections {
  line-height: 26px !important;
}
>>>.v-select__selection--comma {
  color: #a80e00 !important;
}
>>>.v-input .v-label {
    height: 26px;
    line-height: 26px;
  }
>>>.v-list-item__title {
    line-height: 26px !important;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: white !important;
  color: #a80e00 !important;
  border-width: thin !important;
  box-shadow: none !important;
}

/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
>>>.theme--light.v-data-table thead tr:last-child th {
    border-bottom: thin solid rgba(0,0,0,.12);
    background: #a80e00 !important;
    color: white !important;
}
>>>.v-data-table__wrapper {
    border-radius: 14px;
}

>>>.theme--light.v-data-table {
    border-radius: 14px !important;
    margin-bottom: 20px !important;
}
/* >>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/listReport/ListrequestHelp.vue